import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AttrOption } from '../../../model/attr/option';
import { Classification } from '../../../model/attr/classification';
import { NecClassificationOptionSelectService } from './classification-option-select.service';
import { NecMultiSelectData } from '../../selects/multi-select/multi-select-data';
import { SelectedInfo } from '../../selects/multi-select/selected-info';

@Component({
  selector: 'nec-classification-option-select',
  templateUrl: './classification-option-select.component.html',
  styleUrls: ['./classification-option-select.component.scss'],
  providers: [NecClassificationOptionSelectService]
})
export class NecClassificationOptionSelectComponent implements OnInit {
  @Input() classification: Classification;
  @Input() selectedClassificationIds: number[] = [];
  @Output() selectChange: EventEmitter<AttrOption[]> = new EventEmitter();
  multiSelectData: NecMultiSelectData;
  selectedValues: string[];

  constructor(private service: NecClassificationOptionSelectService) { }

  ngOnInit() {
    this.multiSelectData = this.service.getMultiSelectData(this.classification);
    setTimeout(() => {
      this.selectedValues = this.service.getSelectedValues(this.multiSelectData, this.selectedClassificationIds);
    });
  }

  targetChanged(info: SelectedInfo) {
    if (!info.changeItem) {
      this.selectChange.emit([]);
      return;
    }
    let ids = info.selectedItems.map(item => +item);
    this.selectChange.emit(this.service.getSelectedClassificationOptions(this.classification, ids));
  }

}
